import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { generateStyle } from '@/utils';
import classes from './emailVerification.module.css';
/**
 * EmailVerification 组件
 * @param {string}   email      - 要展示的邮箱
 * @param {boolean}  isOpen     - 是否显示该组件（由外部控制）
 * @param {function} onClose    - 点击“回退”按钮时触发，用于让父组件把 isOpen 设为 false
 * @param {function} onResend   - 点击“重发邮件”时触发，在此可以调用接口或其他逻辑
 * @param {string} loginAccessToken   - 点击“重发邮件”时需要判断是否有携带登录信息的token
 * @param {boolean} loginAccessStatus   - 用于标识是否初始化已经请求过
 */
export const EmailVerification = (props) => {
  const {
    email, isOpen, onClose, onResend, loginAccessToken, loginAccessStatus, loginEmailSend, resendTimeLimit = 60, customStyleConfig = {},
  } = props;
  const { t } = useTranslation();
  // 倒计时状态（秒），默认 60s
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);

  const emailVerificationText = loginAccessStatus === 200053
    ? t('Your verification link has expired. A new verification email was sent to you at {{email}}.', { email })
    : t('A verification email was sent to you at {{email}}.', { email });

  // 当组件一旦“打开”时，就重置并开始计时
  useEffect(() => {
    if (isOpen && loginAccessToken && loginEmailSend) {
      setCountdown(resendTimeLimit);
    }
  }, [isOpen, loginAccessToken, loginEmailSend]);

  // 每秒钟减一，直到到 0 为止
  useEffect(() => {
    let timer;
    if (isOpen && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isOpen, countdown]);

  // 如果不打开，就不渲染任何内容（避免占 DOM 空间）
  if (!isOpen) return null;

  // 点击“重发”时，重新开始 60s 倒计时，并调用外部的 onResend
  const handleResend = async () => {
    setLoading(true);
    const result = await onResend?.();
    if (result) {
      setCountdown(resendTimeLimit);
    }
    setLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <Button className={classes.backButton} onClick={onClose} type="text">
          <ArrowBackIcon />
        </Button>

        <div className={classes.content}>
          <p
            className={classes.title}
            style={{
              ...generateStyle(customStyleConfig?.display),
            }}
          >
            {emailVerificationText}
          </p>

          <p
            className={classes.desc}
            style={{
              ...generateStyle(customStyleConfig?.display),
            }}
          >
            {t("Didn't get it?")}
            <Button
              className={`${countdown > 0 ? classes.disableResendLink : classes.resendLink} ${classes.buttonText}`} // 给 resend email 按钮加上紫色文字
              disabled={countdown > 0}
              loading={loading}
              onClick={handleResend}
              type="text"

            >
              {t('Resend email {{countdownTime}}', { countdownTime: countdown > 0 ? `(${countdown}s)` : '' })}
            </Button>
          </p>
        </div>
      </div>
    </div>
  );
};
